import { BillingCycle, Currency } from '@prezly/sdk';

import type * as Pricing from '@/pricing/types';

export function getPrice(
    prices: Pricing.PriceMap,
    billingCycle: BillingCycle,
    currency: Currency.USD | Currency.EUR,
): string;

export function getPrice(
    prices: Pricing.PriceMap | undefined,
    billingCycle: BillingCycle,
    currency: Currency.USD | Currency.EUR,
): string | undefined;

export function getPrice(
    prices: Pricing.PriceMap | undefined,
    billingCycle: BillingCycle,
    currency: Currency.USD | Currency.EUR,
): string | undefined {
    if (!prices) {
        return undefined;
    }

    const isEuro = currency === Currency.EUR;

    const divideBy = billingCycle === BillingCycle.MONTH ? 100 : 100 * 12;
    const finalPrice = (prices[billingCycle]?.[currency] ?? 0) / divideBy;

    return isEuro ? `${finalPrice}€` : `$${finalPrice}`;
}
